/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchPageContext } from './';
import {
    SourcingSearchPageContextFromJSON,
    SourcingSearchPageContextFromJSONTyped,
    SourcingSearchPageContextToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchByIdentifierRequest
 */
export interface SourcingSearchByIdentifierRequest {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchByIdentifierRequest
     */
    identifier: string;
    /**
     * 
     * @type {SourcingSearchPageContext}
     * @memberof SourcingSearchByIdentifierRequest
     */
    pageContext?: SourcingSearchPageContext;
}

/**
 * Check if a given object implements the SourcingSearchByIdentifierRequest interface.
 */
export function instanceOfSourcingSearchByIdentifierRequest(value: object): value is SourcingSearchByIdentifierRequest {
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    return true;
}

export function SourcingSearchByIdentifierRequestFromJSON(json: any): SourcingSearchByIdentifierRequest {
    return SourcingSearchByIdentifierRequestFromJSONTyped(json, false);
}

export function SourcingSearchByIdentifierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchByIdentifierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'identifier': json['identifier'],
        'pageContext': json['pageContext'] == null ? undefined : SourcingSearchPageContextFromJSON(json['pageContext']),
    };
}

export function SourcingSearchByIdentifierRequestToJSON(value?: SourcingSearchByIdentifierRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identifier': value['identifier'],
        'pageContext': SourcingSearchPageContextToJSON(value['pageContext']),
    };
}

